export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "ShiftMasterImportWorker.7960030baf2487c81647.worker.js");
}
